import React, { useState, useEffect } from 'react';
import { fetchAllocatedMedications } from '../../services/medicationService';

const AllocatedMedicationTab = ({ serverId }) => {
    const [stocks, setStocks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const loadStocks = async () => {
            try {
                setIsLoading(true);
                const data = await fetchAllocatedMedications(serverId);
                setStocks(data);
            } catch (err) {
                console.error("Failed to load allocated medications", err);
            } finally {
                setIsLoading(false);
            }
        };
        loadStocks();
    }, [serverId]);

    const filteredStocks = stocks.filter(stock => {
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            const hay = `${stock.name || ''} ${stock.userId || ''} ${stock.userName || ''}`.toLowerCase();
            return hay.includes(term);
        }
        return true;
    });

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', alignItems: 'center' }}>
                <h2 style={{ fontSize: '20px', color: '#2d3748', margin: 0 }}>Allocated Medication Stocks</h2>
                
                <input 
                    type="text"
                    placeholder="Search by medication or user..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', minWidth: '250px' }}
                />
            </div>

            {isLoading ? (
                <div style={{ padding: '40px', textAlign: 'center', color: '#718096' }}>Loading stocks...</div>
            ) : filteredStocks.length === 0 ? (
                <div style={{ padding: '40px', textAlign: 'center', backgroundColor: '#f7fafc', borderRadius: '8px', color: '#718096' }}>
                    No allocated medications found.
                </div>
            ) : (
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                        <thead style={{ backgroundColor: '#f7fafc', borderBottom: '2px solid #e2e8f0' }}>
                            <tr>
                                <th style={{ padding: '12px 16px', textAlign: 'left', color: '#4a5568', fontSize: '14px', fontWeight: '600' }}>User</th>
                                <th style={{ padding: '12px 16px', textAlign: 'left', color: '#4a5568', fontSize: '14px', fontWeight: '600' }}>Medication Name</th>
                                <th style={{ padding: '12px 16px', textAlign: 'right', color: '#4a5568', fontSize: '14px', fontWeight: '600' }}>Current Stock</th>
                                <th style={{ padding: '12px 16px', textAlign: 'right', color: '#4a5568', fontSize: '14px', fontWeight: '600' }}>Low Stock Alert</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredStocks.map((stock, index) => {
                                const currentStock = parseInt(stock.currentStock || 0, 10);
                                const alertStock = parseInt(stock.alertStock || 0, 10);
                                const isLow = currentStock <= alertStock;

                                return (
                                    <tr key={`${stock.userId}-${stock.id}-${index}`} style={{ borderBottom: '1px solid #e2e8f0' }}>
                                        <td style={{ padding: '12px 16px', color: '#2d3748', fontSize: '14px' }}>
                                            {stock.userName || stock.userId || 'Unknown'}
                                        </td>
                                        <td style={{ padding: '12px 16px', color: '#2d3748', fontSize: '14px', fontWeight: '500' }}>
                                            {stock.name || 'Unknown Medication'}
                                        </td>
                                        <td style={{ padding: '12px 16px', color: isLow ? '#e53e3e' : '#2d3748', fontSize: '14px', fontWeight: 'bold', textAlign: 'right' }}>
                                            {currentStock}
                                        </td>
                                        <td style={{ padding: '12px 16px', color: '#718096', fontSize: '14px', textAlign: 'right' }}>
                                            {alertStock}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default AllocatedMedicationTab;
